import { Pipe, PipeTransform } from '@angular/core';
import { BoundActionFn, TableColumnMetadata, TableRow } from 'src/app/table-handling';

@Pipe({
  name: 'cellAction',
  standalone: true
})

export class CellActionPipe implements PipeTransform {
  transform(meta: TableColumnMetadata | undefined, row: TableRow): BoundActionFn | undefined {
    if (meta?.actionExcludeGroupHeader && row.meta?.isGroupHeader) {
      return undefined;
    }

    return meta?.action;
  }
}
